import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "input", "state"]

  connect() {
    this.toggle()
  }

  toggle() {
    const enabled = this.inputTarget.checked
    this.panelTarget.classList.toggle("hidden", !enabled)
    this.stateTarget.textContent = enabled ? "Sí" : "No"
  }
}
